
<ng-container *ngIf="callLegs | async as _callLegs; else loading;">


  <!--$(".telepoCdrsButton").style.display = "block"-->
  <button mat-flat-button style="display: none; background-color:#00B3CE; color:#FFFFFF; font-weight:bold;" class="telepoCdrsButton" (click)="openDialog(node)">
    Cdrs
  </button>

  <table mat-table [dataSource]="_callLegs">

    <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->
    <!-- Position Column -->

    <ng-container matColumnDef="Children">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let row">

        <ng-container *ngIf="row.divert != true && row.parentCall == null && row.childCalls?.length > 0">
          {{ expandedCallIds.has(row.callId) == false ? '+' : '-'}}
        </ng-container>

      </td>
    </ng-container>

    <ng-container matColumnDef="StartTime">
      <th mat-header-cell *matHeaderCellDef> StartTime </th>
      <td mat-cell *matCellDef="let row"> {{row.startTime | date: 'dd/MM/yyyy HH:mm:ss'}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Source">
      <th mat-header-cell *matHeaderCellDef> Source </th>
      <td mat-cell *matCellDef="let row">
        <span class="material-icons" style="position: relative; top: 6px;" matTooltip="{{ row.sourceApType  | telepoCdrApTypePipe_Name}} - {{ row.result  | telepoCdrResult}}" [style.color]="row.result  | telepoCdrResultColorPipe">{{ row.sourceApType  | telepoCdrApTypePipe_Icon}}</span>
        <span class="material-icons" style="position: relative; top: 6px;" [tooltip]="sourceMosTooltip" hideDelay="0" width="1000" contentType="template" tooltipClass="fixed-tooltip" [style.color]="row.sourceMOS | mosResultColorPipe">volume_up</span>

        <ng-template #sourceMosTooltip>
          <ng-container *ngTemplateOutlet="mosTooltip;context:{title:'From', callQuality:{ mos:row.sourceMOS, avgJitter: row.sourceAvgJitter, maxJitter: row.sourceMaxJitter, packetLoss : row.sourcePacketsLost , avgLatency: row.sourceAvgLatency, maxLatency: row.sourceMaxLatency}}"></ng-container>
        </ng-template>

        <ng-container *ngIf="row.sourceOwnerId != null; else sourcePhoneNumber">
          {{row.sourceOwnerTypeId | ownerTypeIdToString}}:
          {{row.sourceOwner}}
        </ng-container>

        <ng-template #sourcePhoneNumber>
          {{row.sourcePhoneNumber }}
        </ng-template>



      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="Target">
      <th mat-header-cell *matHeaderCellDef> Target </th>
      <td mat-cell *matCellDef="let row">
        <span class="material-icons" style="position: relative; top: 6px;" matTooltip="{{ row.targetApType  | telepoCdrApTypePipe_Name}} - {{  row.result  | telepoCdrResult}}" [style.color]="row.result  | telepoCdrResultColorPipe">{{ row.targetApType  | telepoCdrApTypePipe_Icon}}</span>
        <span class="material-icons" style="position: relative; top: 6px;" [tooltip]="targetMosTooltip" hideDelay="0" width="1000" contentType="template" tooltipClass="fixed-tooltip" [style.color]="row.sourceMOS | mosResultColorPipe">volume_up</span>
        <ng-template #targetMosTooltip>
          <ng-container *ngTemplateOutlet="mosTooltip;context:{title:'To', callQuality:{ mos:row.targetMOS, avgJitter: row.targetAvgJitter, maxJitter: row.targetMaxJitter, packetLoss : row.targetPacketsLost , avgLatency: row.targetAvgLatency, maxLatency: row.targetMaxLatency}}"></ng-container>
        </ng-template>

        <ng-container *ngIf="row.targetOwnerId != null">
          {{row.targetOwnerTypeId | ownerTypeIdToString}}:
          {{row.targetOwner}}
        </ng-container>

        <ng-container *ngIf="row.targetOwnerId == null">
          {{row.targetPhoneNumber.BlankToNull() ??  row.dialString}}
        </ng-container>

        <!--<span *ngIf="row.diversionReason != null"><span class="material-icons" style="position: relative; top: 6px;" matTooltip="Diversion Reason: {{row.diversionReason | telepoCdrDiversionReason}}">info</span></span>-->
        <span *ngIf="row.transferredBy ?? '' != ''"><span class="material-icons" style="position: relative; top: 6px;" matTooltip="Transferred by {{row.transferredBy}}">swap_horiz</span></span>
        <span *ngIf="row.divertedBy ?? '' != ''"><span class="material-icons" style="position: relative; top: 6px;" matTooltip="Diverted by {{row.divertedBy}}">swap_horiz</span></span>


      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="Duration">
      <th mat-header-cell *matHeaderCellDef> Duration </th>
      <td mat-cell *matCellDef="let row">
        {{row.duration / 1000 | secondsToTimeSpan}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['Children','StartTime', 'Source', 'Target', 'Duration']"></tr>
    <tr mat-row
        *matRowDef="let row; columns: ['Children','StartTime', 'Source', 'Target', 'Duration'];"
        (click)="rowClick(row)"
        [style.display]="row.parentCall == null || expandedCallIds.has(row.parentCall.callId) ? 'table-row' : 'none'"
        [class.divertCall]="row.divert == true"
        [class.childCall]="row.parentCall != null"
        [class.activeCall]="row.completed == false"
        [style.cursor]="row.divert != true && row.parentCall == null && row.childCalls?.length > 0 ? 'pointer' : ''"
        ></tr>

  </table>

</ng-container>




<ng-template #mosTooltip let-title="title" let-callQuality="callQuality">
  <div style="font-family: Comfortaa">
    <h3 style="margin: 5px 0;">Call Quality</h3>

    <table class="mosTooltipTable">
      <tr>
        <th style="text-align:left; width: 175px;">{{title}}</th>
        <th style="width: 100px;">Avg</th>
        <th style="width: 100px;">Max</th>
      </tr>
      <tr>
        <td style="text-align:left">Mos</td>
        <td>{{callQuality.mos}}</td>
        <td>-</td>
      </tr>
      <tr>
        <td style="text-align:left">Jitter</td>
        <td>{{callQuality.avgJitter}}</td>
        <td>{{callQuality.maxJitter}}</td>
      </tr>
      <tr>
        <td style="text-align:left">Packet Loss</td>
        <td>-</td>
        <td>{{callQuality.packetLoss}}</td>
      </tr>
      <tr>
        <td style="text-align:left">Latency</td>
        <td>{{callQuality.avgLatency}}</td>
        <td>{{callQuality.maxLatency}}</td>
      </tr>
    </table>
  </div>  
</ng-template>




<ng-template #loading>
  <div style="color: gray; display: block; text-align: center;">
    <span class="fa fa-spinner fa-pulse fa-5x" style="color: gray; display: inline-block;"></span>

  </div>
</ng-template>
